import type { SlideProps } from '@mui/material/Slide';

import Slide from '@mui/material/Slide';
import * as React from 'react';

export const DialogTransition: React.ForwardRefExoticComponent<Omit<SlideProps, 'ref'> & React.RefAttributes<unknown>> =
    React.forwardRef((props: SlideProps, ref: React.Ref<unknown>): React.ReactElement<SlideProps> => {
        return (
            <Slide direction="up" {...props} ref={ref}/>
        );
    });